import { createSlice } from '@reduxjs/toolkit';
import FJTextToImageDataConfig from '../../config/dataConfig/FJTextToImageDataConfig';
import FJTextToImageConstant from '../../constants/FJTextToImageConstant';

export const FJSliceTextToImage = createSlice({
    name: 'textToImage',
    initialState: {
        prompt: '',
        curStyle: {
            value: '',
            name: 'none',
            previewImg: 'none.jpg',
        },
        curModel: FJTextToImageDataConfig.MODELS[0].value,
        curRatio: FJTextToImageDataConfig.RATIO_LIST[0].name,
        generateNumber: localStorage.getItem('generateNumber')
            ? Number(localStorage.getItem('generateNumber'))
            : FJTextToImageDataConfig.IMAGE_NUMBER_LIST[1].value,
        promptStatus: FJTextToImageConstant.NORMAL,

        styleList: [],
        curGeneratingPromptImageUrl: '/public/img/textToImage/styles/test.jpg',

        inspireList: [],
        presetImageList: [],
        isShowPresetImageBox: true,
    },
    reducers: {
        setSlicePrompt: (state, action) => {
            state.prompt = action.payload;
        },
        setSlicePromptStatus: (state, action) => {
            state.promptStatus = action.payload;
        },
        setSliceStyle: (state, action) => {
            state.curStyle = action.payload;
        },
        setSliceModel: (state, action) => {
            state.curModel = action.payload;
        },
        setSliceRatio: (state, action) => {
            state.curRatio = action.payload;
        },
        setSliceGenerateNumber: (state, action) => {
            state.generateNumber = action.payload;
        },
        setSliceStyleList: (state, action) => {
            state.styleList = action.payload;
        },
        setSliceCurGeneratingPromptImageUrl: (state, action) => {
            state.curGeneratingPromptImageUrl = action.payload;
        },
        setSliceInspireList: (state, action) => {
            state.inspireList = action.payload;
        },
        setSlicePresetImageList: (state, action) => {
            state.presetImageList = action.payload;
        },
        setSliceIsShowPresetImageBox: (state, action) => {
            state.isShowPresetImageBox = action.payload;
        },
    },
});

export const {
    setSlicePrompt,
    setSlicePromptStatus,
    setSliceStyle,
    setSliceModel,
    setSliceRatio,
    setSliceGenerateNumber,
    setSliceStyleList,
    setSliceCurGeneratingPromptImageUrl,
    setSliceInspireList,
    setSlicePresetImageList,
    setSliceIsShowPresetImageBox,
} = FJSliceTextToImage.actions;

export default FJSliceTextToImage.reducer;
